import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';

import {Picker} from '../Picker';

storiesOf('base', module).add('Picker', () => (
  <ScrollView>
    <Spacing size={20}>
      <Heading level={1}>Picker Component</Heading>
      <Spacer size={16} />
      <Text>
        This is the <Code>{'Picker'}</Code> component.
      </Text>
      <Spacer size={16} />
      <Text>Renders the native picker component on Android and iOS.</Text>
      <Spacer size={16} />
      <Picker items={['item1', 'item2', 'item3']} />
      <Spacer size={20} />
      <Text>We can set initial value</Text>
      <Spacer size={16} />
      <Picker
        selectedItem={1}
        items={['item1', 'item2', 'item3']}
        setSelectedItem={() => {}}
      />
    </Spacing>
  </ScrollView>
));
